module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"badRequestError":"There seems to be an issue with the request","networkError":"There was a error in the connection, please try again later"},"de":{"badRequestError":"Es gibt ein Problem mit der Anfrage","networkError":"Bei der Verbindung ist ein Fehler aufgetreten, versuchen Sie es bitte später nochmals"}}')
  delete Component.options._Ctor
}
